var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-content"},[_c('div',{staticClass:"faq"},_vm._l((_vm.imgList),function(item,index){return _c('img',{attrs:{"src":_vm.isMaxScreen ? item.image1 : item.image,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }